<h2>Stats Overview</h2>
<div class="container">
  <div>
    <mat-form-field class="full-width">
      <mat-label>Resolution</mat-label>
      <mat-select [(ngModel)]="selectedResolution">
        @for (resolution of resolutions; track resolution) {
          <mat-option [value]="resolution">
            {{resolution}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>Filter by Client</mat-label>
      <mat-select [(ngModel)]="selectedClientId">
        <mat-option>
          Show All
        </mat-option>
          @for (client of clients(); track client) {
          <mat-option [value]="client.clientId">
            {{client.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="full-width">
      <mat-label>Filter by Customer</mat-label>
      <mat-select [(ngModel)]="selectedCustomerId">
        <mat-option>
          Show All
        </mat-option>
          @for (customer of customers(); track customer) {
          <mat-option [value]="customer.id">
            {{customer.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="right-inner">
    <mat-form-field>
      <input matInput [matDatepicker]="picker" placeholder="Start Date" [(ngModel)]="fromDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <input matInput [matDatepicker]="picker2" placeholder="End Date" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
    <p>You can optionally filter on certain dates, both start and end date are inclusive.</p>
    <button mat-raised-button (click)="clearDates()">Clear Dates</button>
    <button mat-raised-button (click)="currentMonth()">Current Month</button>
    <button mat-raised-button (click)="lastMonth()">Last Month</button>
  </div>
</div>

<da-stats-overview-graph [resolution]="selectedResolution" [stats]="conversionStats()"></da-stats-overview-graph>
